import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  productDetailHero: {
    backgroundColor: theme.palette.yellow,
    position: "relative",
    paddingBottom: '2rem'
  },
  productDetailHeroCenter: {
    position: "relative",
    margin: '0 auto',
    maxWidth: theme.limits.lg
  },
  backgroundContainer: {
    backgroundColor: theme.palette.darkPurple,
    position: "absolute",
    width: "100%",
    overflow: "hidden",
    height: "calc(30% + 3rem)",
    [theme.breakpoints.up('md')]: {
      height: "calc(24% + 3rem)"
    },
    [theme.breakpoints.up('lg')]: {
      height: "calc(38% + 4rem)"
    },
    [theme.breakpoints.up('xl')]: {
      height: "calc(38% + 4rem)"
    },
    "&::after": {
      left: "0",
      right: "0",
      bottom: "-1.5rem",
      height: "4rem",
      content: '""',
      position: "absolute",
      transform: "skewY(-3deg)",
      background: "#f8df10",
      zIndex: "0",
      [theme.breakpoints.up('md')]: {
        transform: "skewY(-2deg)",
        bottom: "-2.063rem"
      },
    }
  },
  backgroundImageContainer: {
    position: "absolute",
    width: "100%",
    top: "0",
  },
  backgroundImage: {
    top: "0",
    width: '23.438rem',
    left: "calc(50% - 11.719rem)",
    zIndex: "0",
    position: "absolute",
    [theme.breakpoints.up('md')]: {
      width: '28.125rem',
      left: "calc(50% - 14.8rem)",
    },
    [theme.breakpoints.up('lg')]: {
      width: "100%",
      left: "0"
    },
  },
  productDetailContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up('lg')]: {
      flexDirection: "row",
    },
  },
  productDetailColumn: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    zIndex: 1,
    '&:first-child': {
      marginBottom: '2rem',
    },
  },
  heroImage: {
    margin: "auto 0",
    width: "20rem",
    marginTop: "1.3rem",
    marginLeft: "calc(50% - 10rem)",
    [theme.breakpoints.up('md')]: {
      width: "29rem",
      marginLeft: "calc(58% - 18rem)"
    },
    [theme.breakpoints.up('lg')]: {
      width: "33rem",
      marginTop: "3rem",
      marginLeft: "calc(51% - 15rem)"
    },
    [theme.breakpoints.up('xl')]: {
      width: "44rem",
      marginTop: "3rem",
      marginLeft: "calc(52% - 21rem)"
    }
  },
  productDetailContent: {
    margin: "0 auto",
    maxWidth: "21.5rem",
    [theme.breakpoints.up('sm')]: {
      maxWidth: "33rem",
      marginTop: "unset",
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: "33rem",
      marginTop: "2%",
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: "28rem",
      marginTop: "16rem",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "38.5rem",
      marginTop: "20.8rem",
    }
  },
  titleContainer: {
    position: "relative",
    marginBottom: "1.5rem",
    [theme.breakpoints.up('lg')]: {
      height: "4rem",
      marginBottom: "3.4rem",
    },
  },
  title: {
    display: "flex",
    flexDirection: "column-reverse",
    color: theme.palette.purple,
    fontSize: "3.8rem",
    width: "100%",
    textAlign: "center",
    height: "auto",
    [theme.breakpoints.up('md')]: {
      fontSize: "4rem"
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: "3.6rem",
      textAlign: "left",
      color: theme.palette.white,
      position: "absolute",
      bottom: "0",
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: "5rem"
    },
  },
  paragraph: {
    padding: "0 1.25rem",
    "& p": {
      height: "auto",
      marginBottom: "2rem",
      fontSize: "1.5rem",
      padding: "0 0.5rem",
      [theme.breakpoints.up('md')]: {
        padding: "0",
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: "1.5rem"
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: "2rem"
      }
    }
  },
  ctasContainer: {
    display: "flex",
    justifyContent: "left",
    margin: "0 auto"
  },
  bottomBackgroundImage: {
    margin: "0 auto",
    maxWidth: "20rem",
    display: "block",
    [theme.breakpoints.up('md')]: {
      maxWidth: "44rem",
    }

  },
  hidden: {
    display: "none"
  },
  nutrition_div:{
    display: 'flex',
    justifyContent: 'center',
    padding: '0.5rem 0 2.5rem 0',
    width: '100%',
    height: 'auto',
    backgroundColor: theme.palette.yellow
  },
}));
